module.exports = __webpack_public_path__ + "media/img/pages/companies/hays-new-aae0ddbec028b26cdd28bd311afee4fc.png";